import { render } from "./InfoDisplay.vue?vue&type=template&id=1feca33a&scoped=true"
import script from "./InfoDisplay.vue?vue&type=script&lang=js"
export * from "./InfoDisplay.vue?vue&type=script&lang=js"

import "./InfoDisplay.vue?vue&type=style&index=0&id=1feca33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1feca33a"]])

export default __exports__